module.exports = __webpack_public_path__ + "20260128d142218t/img/pic_wangluoweilianjie@2x.a82041ec.png";